/* Greenleaf — "Show more" on the shelves (12 Oct 2026, site audit, Andrew's yes).
 *
 * The markup is in snippets/gl-cards.liquid: a count line and a "Show more" LINK to the next
 * ?page=. Without this file that link simply opens the next page, and the numbered pager under it
 * stays for Google and for anyone without JavaScript.
 *
 * With it, pressing "Show more":
 *   - fetches ONLY this section for the next page (Section Rendering API: the same URL plus
 *     section_id), so the filters and sort already in the URL come along unchanged;
 *   - appends that page's cards to the grid, so the scroll position does not move;
 *   - updates "Showing … of …", points the button at the page after, or removes it at the end;
 *   - replaces the address with the loaded ?page= (history.replaceState: no extra Back steps);
 *   - on a keyboard press, moves focus to the first new card, so a keyboard user carries on
 *     from where the new pieces start instead of from below them.
 * If the fetch fails it falls back to opening the next page normally.
 * Filters and sort are real links and GET forms that reload the page, so each shelf view starts
 * fresh at its own ?page= with this file run once.
 *
 * BACK KEEPS YOUR PLACE (12 Oct 2026, Andrew's yes). The address holds only the LAST page loaded, so
 * a browser that reloads the shelf on Back would show that page alone and at the top. The shelf
 * therefore writes a small note in sessionStorage (this tab only, gone when it closes): the page it
 * was opened at, the last page loaded, and how far down the shopper was, saved when they leave. On
 * Back (and only on Back or Forward) the earlier pages are fetched, put in front in order, the
 * count line is made true again, and the scroll goes back to where it was. The grid stays hidden for
 * that moment so nothing jumps, with a 5 second cap, after which the shelf shows as it came. A browser
 * that keeps the whole page for Back (bfcache) never needs any of it. The note is per shelf AND per
 * filter and sort in the address, so each view remembers its own place.
 */
(function () {
  'use strict';
  if (window.__glShowMore) return;
  window.__glShowMore = true;
  if (!window.fetch || !window.DOMParser || !document.querySelector) return;

  // While there is more to show, the numbered pager is redundant: hide it (it stays in the HTML).
  function tidy(scope) {
    var walls = (scope || document).querySelectorAll('[data-more]');
    for (var i = 0; i < walls.length; i++) {
      var sec = walls[i].parentNode;
      var pager = sec ? sec.querySelector('[data-pager]') : null;
      if (pager && walls[i].querySelector('[data-more-next]')) pager.hidden = true;
    }
  }
  tidy();

  // ---- the place on the shelf, kept for Back ----
  function pageOf(search) {
    var m = /[?&]page=(\d+)/.exec(search);
    return m ? parseInt(m[1], 10) : 1;
  }
  var KEY = (function () {
    var q = new URLSearchParams(window.location.search);
    q.delete('page'); q.delete('section_id');
    q.sort();
    return 'glShelfPlace:' + window.location.pathname + '?' + q.toString();
  })();
  var curPage = pageOf(window.location.search);
  var startPage = curPage, lastPage = curPage;
  var old = null;
  try { old = JSON.parse(window.sessionStorage.getItem(KEY)); } catch (e) {}
  var nav = window.performance && performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
  var byHistory = nav ? nav.type === 'back_forward' : !!(performance.navigation && performance.navigation.type === 2);
  var extra = byHistory && old && old.l === curPage && old.s < curPage;
  if (extra) startPage = old.s;
  // The page the shelf was opened at. Opened at ?page=2 or later, the earlier pages are only
  // reachable through the numbered pager, so it comes back once the last page is showing.
  var openedLater = startPage > 1;

  function save() {
    try {
      window.sessionStorage.setItem(KEY, JSON.stringify({ s: startPage, l: lastPage, y: Math.round(window.pageYOffset) }));
    } catch (e) {}
  }
  window.addEventListener('pagehide', save);
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('li.card a')) save();
  }, true);

  if (byHistory && old && old.l === curPage) {
    (function restore(o) {
      var wall = document.querySelector('[data-more]');
      var sec = wall && sectionOf(wall);
      var grid = sec ? sec.querySelector('ul.grid') : null;
      if (!grid) return;
      var done = false;
      try { window.history.scrollRestoration = 'manual'; } catch (e) {}
      // Scroll anchoring would push the page down by the height of the cards put in front; switched
      // off while the place is put back, then restored.
      var root = document.documentElement;
      root.style.overflowAnchor = 'none';
      // Once the shopper scrolls themselves, the place is theirs and is not put back again.
      var moved = false;
      ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(function (ev) {
        window.addEventListener(ev, function () { moved = true; }, { once: true, passive: true });
      });
      function put() { if (!moved) window.scrollTo(0, o.y); }
      function finish() {
        if (done) return;
        done = true;
        grid.style.visibility = '';
        put();
        window.requestAnimationFrame(put);
        window.addEventListener('load', put);
        setTimeout(function () {
          put();
          root.style.removeProperty('overflow-anchor');
          try { window.history.scrollRestoration = 'auto'; } catch (e) {}
        }, 1200);
      }
      if (o.s >= o.l) { finish(); return; }
      grid.style.visibility = 'hidden';
      setTimeout(finish, 5000);
      var sid = sec.id.replace('shopify-section-', '');
      var jobs = [];
      for (var p = o.s; p < o.l; p++) {
        (function (n) {
          var u = new URL(window.location.href);
          u.searchParams.set('page', n);
          u.searchParams.set('section_id', sid);
          jobs.push(fetch(u.href, { credentials: 'same-origin' })
            .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
            .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); }));
        })(p);
      }
      Promise.all(jobs).then(function (docs) {
        var firstOld = grid.firstElementChild;
        docs.forEach(function (doc) {
          var cards = doc.querySelectorAll('ul.grid > li.card');
          for (var i = 0; i < cards.length; i++) grid.insertBefore(document.importNode(cards[i], true), firstOld);
        });
        // "Showing 61 to 120 of 197" becomes "Showing 1 to 120 of 197": the first page's own opening
        // words with this page's last number.
        var count = wall.querySelector('.more__count');
        var head = docs[0].querySelector('.more__count');
        var to = wall.querySelector('[data-more-to]');
        if (count && head && to) {
          var last = to.textContent;
          count.innerHTML = head.innerHTML;
          var t2 = count.querySelector('[data-more-to]');
          if (t2) t2.textContent = last;
        }
      }).catch(function () {}).then(finish);
    })(old);
  }

  function sectionOf(el) {
    return el.closest ? el.closest('[id^="shopify-section-"]') : null;
  }

  function load(a, byKeyboard) {
    if (a.getAttribute('aria-busy') === 'true') return;
    var wall = a.closest('[data-more]');
    var sec = sectionOf(a);
    var grid = sec ? sec.querySelector('ul.grid') : null;
    if (!wall || !sec || !grid) { window.location.href = a.href; return; }

    var page = new URL(a.href, window.location.href);
    var req = new URL(page.href);
    req.searchParams.set('section_id', sec.id.replace('shopify-section-', ''));

    var label = a.textContent;
    a.setAttribute('aria-busy', 'true');
    a.textContent = 'Loading';

    // PLACEHOLDERS (13 Oct 2026). The shelf grows at the moment of the tap, not when the answer
    // lands: as many quiet copies of the last card as will arrive go in now, so the button and the
    // footer move while the tap still counts as the cause (no layout shift is scored), and the real
    // cards then take their places one for one. Measured before this: 0.09 shift on a phone.
    var size = +wall.getAttribute('data-more-size') || 0;
    var total = +wall.getAttribute('data-more-total') || 0;
    var toEl = wall.querySelector('[data-more-to]');
    var seen = toEl ? +toEl.textContent || 0 : 0;
    var want = Math.max(0, Math.min(size, total - seen));
    var holders = [];
    var model = grid.querySelector('li.card:last-of-type');
    if (model) {
      for (var h = 0; h < want; h++) {
        var ph = model.cloneNode(true);
        ph.className = 'card card--ph';
        ph.removeAttribute('data-sold');
        ph.setAttribute('aria-hidden', 'true');
        var imgs = ph.querySelectorAll('img, video');
        for (var k = 0; k < imgs.length; k++) imgs[k].parentNode.removeChild(imgs[k]);
        var links = ph.querySelectorAll('a');
        for (var q = 0; q < links.length; q++) { links[q].removeAttribute('href'); links[q].setAttribute('tabindex', '-1'); }
        grid.appendChild(ph);
        holders.push(ph);
      }
    }
    function clearHolders() { holders.forEach(function (x) { if (x.parentNode) x.parentNode.removeChild(x); }); holders = []; }

    fetch(req.href, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cards = doc.querySelectorAll('ul.grid > li.card');
        if (!cards.length) throw new Error('no cards');
        var first = null;
        for (var i = 0; i < cards.length; i++) {
          var n = document.importNode(cards[i], true);
          // Arrival ripple (13 Oct 2026): each new card rises in 40 ms after the one before,
          // capped at 12 so the last cards do not wait. CSS .card.is-arriving; nothing under
          // reduced motion. Transform and opacity only, so nothing else on the page moves.
          n.classList.add('is-arriving');
          n.style.setProperty('--i', Math.min(i, 12));
          if (holders[i] && holders[i].parentNode) holders[i].parentNode.replaceChild(n, holders[i]);
          else grid.appendChild(n);
          if (!first) first = n;
        }
        holders = holders.slice(cards.length);
        clearHolders();
        setTimeout(function () {
          var arr = grid.querySelectorAll('.card.is-arriving');
          for (var j = 0; j < arr.length; j++) { arr[j].classList.remove('is-arriving'); arr[j].style.removeProperty('--i'); }
        }, 1200);
        try { document.dispatchEvent(new CustomEvent('gl:cards-added')); } catch (e) {}

        var to = doc.querySelector('[data-more-to]');
        var mine = wall.querySelector('[data-more-to]');
        if (to && mine) mine.textContent = to.textContent;

        var next = doc.querySelector('[data-more-next]');
        if (next) {
          a.href = new URL(next.getAttribute('href'), window.location.href).href;
          a.textContent = label;
          a.removeAttribute('aria-busy');
        } else {
          a.parentNode.removeChild(a);
          var pager = sec.querySelector('[data-pager]');
          if (pager && openedLater) pager.hidden = false;
        }

        try { window.history.replaceState(window.history.state, '', page.pathname + page.search + page.hash); } catch (e) {}
        lastPage = pageOf(page.search);
        save();

        if (byKeyboard && first) {
          var link = first.querySelector('a');
          if (link) { try { link.focus({ preventScroll: true }); } catch (e) { link.focus(); } }
        }
      })
      .catch(function () { clearHolders(); window.location.href = page.href; });
  }

  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[data-more-next]') : null;
    if (!a) return;
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    // A click from the keyboard (Enter on the link) arrives with detail 0.
    load(a, e.detail === 0);
  });

})();
